/**
 *
 * Asynchronously loads the component for ShapeThumbnail
 *
 */

import { lazyLoad } from 'utils/loadable';

export const ShapeThumbnail = lazyLoad(
  () => import('./index'),
  module => module.ShapeThumbnail,
);
